import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import { Link } from 'react-router-dom';

import { withAppContext } from '../../../contexts/app';

//import Button from 'shared/Button';

import ImageUploader from '../../../components/ImageUploader';

class MobileTopCTA extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="condition__mobile__top__cta">
        {/*
        <span className="condition__mobile__top__cta__left">
          <Button className="condition__mobile__top__cta__follow-button">Follow this condition</Button>
        </span>
        */}
        <span className="condition__mobile__top__cta__right">
          {/*<Link to="/get-started" className="condition__mobile__top__cta__get-started-button">Check your symptoms now</Link>*/}

          <ImageUploader
            className="condition__mobile__top__cta__get-started-button"
            label="Check your skin"
            onUpload={this.onImageUpload.bind(this)}
          />
        </span>
      </div>
    );
  }

  onImageUpload(image) {
    this.props.app.onImageUpload(image);
  }
}

MobileTopCTA.defaultProps = {};

MobileTopCTA.propTypes = {
  app: PropTypes.object.isRequired
};

export { MobileTopCTA };
export default withAppContext(MobileTopCTA);
